import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_vacancies,
    CREATE_VACANCIES,
    createVacancies,
    getAllVacancies,
    get_report,
    GET_REPORT,
    getItemVacancies,
    updateVacancies,
    UPDATE_VACANCIES
} from '../../../redux/vacancies';
import LoadingSpinner from "../../../components/loading-spinner";
import {get_status} from "../../../config";
import Card from "../../../components/card";
import Modal from "../../../components/modal";
import CheckBox from "../../../components/check-box";

const VacanciasAdmin = (props) => {
    const dispatch = useDispatch();

    const _get_all_vacancies = useSelector((state) => state.vacancies_module._get_all_vacancies);

    const _create_vacancies = useSelector((state) => state.vacancies_module._create_vacancies);
    const _update_vacancies = useSelector((state) => state.vacancies_module._update_vacancies);

    const _get_report = useSelector((store) => store.vacancies_module._get_report);

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllVacancies(token));
        // eslint-disable-next-line
    }, [token, dispatch]);


    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [modalDecline, setModalDecline] = useState(false);
    const [observation, setObservation] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        fecha_vacante: "",
        establecimiento: "",
        zona: "",
        jefe_area: "",
        subjefe_area: "",
        razon_social: "",
        titulo: "",
        cantidad: 0,
        motivo: "",
        justificativo: "",
        funcion_principal: "",
        condicion: "",
        herramienta_trabajo: "",
        herramienta_informatica: "",
        tiene_correo: false,
        correo: "",
        equipo_proteccion: "",
        tipo_contrato: "",
        jornada_trabajo: "",
        salario: 0.0,
        otro_detalle: "",
        estimado: false,
    };

    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_vacancies.status === 201) {
            toast.success("Vacante creada correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_vacancies(CREATE_VACANCIES));
            dispatch(getAllVacancies(token));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_vacancies.status !== 0) {
            toast.error(_create_vacancies.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_vacancies(CREATE_VACANCIES));
            setIsLoading(false);
        }
    }, [_create_vacancies, dispatch, initForm, token])

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_vacancies && _get_all_vacancies.data && _get_all_vacancies.data.datos) {
            setDatas(_get_all_vacancies.data.datos);
        }

    }, [_get_all_vacancies, count, props]);

    const loadFunc = () => {
        if (_get_all_vacancies.data.datos) {
            if (_get_all_vacancies.data.datos.length > count) {
                const ordenado = _get_all_vacancies.data.datos.sort((a, b) => {
                    return new Date(b.fecha_vacante + ' 00:00:00') - new Date(a.fecha_vacante + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        if (e.target.value === "0") {
            setDatas(_get_all_vacancies.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.name === "cantidad") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else if (e.target.name === "salario") {
            setForm({
                ...form,
                [e.target.name]: parseFloat(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (form.titulo === "") {
            toast.error("Debe ingresar el título");
            setIsLoading(false);
            return;
        }
        if (form.fecha_vacante === "") {
            toast.error("Debe seleccionar la fecha de la vacante");
            setIsLoading(false);
            return;
        }
        if (form.establecimiento === "") {
            toast.error("Debe ingresar la joyería o departamente");
            setIsLoading(false);
            return;
        }
        if (form.zona === "") {
            toast.error("Debe ingresar la zona o área");
            setIsLoading(false);
            return;
        }
        if (form.jefe_area === "") {
            toast.error("Debe ingresar el jefe de área o zona");
            setIsLoading(false);
            return;
        }
        if (form.subjefe_area === "") {
            toast.error("Debe ingresar el sub gerente de área");
            setIsLoading(false);
            return;
        }
        if (form.razon_social === "") {
            toast.error("Debe ingresar la razón social");
            setIsLoading(false);
            return;
        }
        if (form.cantidad === 0) {
            toast.error("Debe ingresar la cantidad");
            setIsLoading(false);
            return;
        }
        if (form.motivo === "") {
            toast.error("Debe ingresar la razón de la vacante");
            setIsLoading(false);
            return;
        }
        if (form.justificativo === "") {
            toast.error("Debe ingresar el justificativo");
            setIsLoading(false);
            return;
        }
        if (form.funcion_principal === "") {
            toast.error("Debe ingresar las funciones principales");
            setIsLoading(false);
            return;
        }
        if (form.funcion_principal === "") {
            toast.error("Debe ingresar las condiciones del espacio físico");
            setIsLoading(false);
            return;
        }
        if (form.herramienta_trabajo === "") {
            toast.error("Debe ingresar las herramientas de trabajos");
            setIsLoading(false);
            return;
        }
        if (form.herramienta_informatica === "") {
            toast.error("Debe ingresar las herramientas informáticas o para cumplimiento de tareas");
            setIsLoading(false);
            return;
        }
        if (form.tiene_correo === true) {
            if (form.correo === "") {
                toast.error("Debe ingresar ingresar el correo");
                setIsLoading(false);
                return;
            }
        }
        if (form.equipo_proteccion === "") {
            toast.error("Debe ingresar los equipos de protección");
            setIsLoading(false);
            return;
        }
        if (form.tipo_contrato === "") {
            toast.error("Debe ingresar el tipo de contrato");
            setIsLoading(false);
            return;
        }
        if (form.jornada_trabajo === "") {
            toast.error("Debe ingresar la jornada de trabajo");
            setIsLoading(false);
            return;
        }
        if (form.salario === 0) {
            toast.error("Debe ingresar el salario");
            setIsLoading(false);
            return;
        }
        if (form.otro_detalle === 0) {
            toast.error("Debe ingresar otros detalles de salario");
            setIsLoading(false);
            return;
        }
        dispatch(createVacancies(token, form));
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_vacancies.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_vacancies.data.datos.filter(element => {
            if (element.establecimiento.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_vacancies.data.datos.filter(x => {
                    if (x.fecha_custodia) {
                        let fecha = new Date(x.fecha_custodia);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_vacancies(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_vacancies(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
        }, token));

    }

    const dataSelectedInit = {
        id: 0,
        secuencial: "",
        fecha_vacante: "",
        establecimiento: "",
        zona: "",
        jefe_area: "",
        subjefe_area: "",
        razon_social: "",
        titulo: "",
        cantidad: 0,
        motivo: "",
        justificativo: "",
        funcion_principal: "",
        condicion: "",
        herramienta_trabajo: "",
        herramienta_informatica: "",
        tiene_correo: false,
        correo: "",
        equipo_proteccion: "",
        tipo_contrato: "",
        jornada_trabajo: "",
        salario: 0.0,
        otro_detalle: "",
        estimado: false,
        estado: "",
        observacion: "",
    }

    const [DataSelected, setDataSelected] = useState(dataSelectedInit);

    const onItemClickListener = async (item) => {
        const response = await getItemVacancies(token, item.id);
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_update_vacancies.status === 200) {
            dispatch(clear_vacancies(UPDATE_VACANCIES));
            toast.success(_update_vacancies.message);
            dispatch(getAllVacancies(token));
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            setIsLoading(false);
            setModalDecline(false);
            setShowDetail(false);
        } else if (_update_vacancies.status !== 0) {
            toast.error(_update_vacancies.message);
            dispatch(clear_vacancies(UPDATE_VACANCIES));
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            setIsLoading(false);
        }
    }, [_update_vacancies, dispatch, token, initForm])

    const handleDecline = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (observation === "") {
            toast.error("Debe ingresar una observación");
            setIsLoading(false);
            return;
        }
        dispatch(updateVacancies(token, DataSelected.id, {"estado": "RECHAZADO", "observacion": observation}));
    }

    const handleApproval = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateVacancies(token, DataSelected.id, {"estado": "APROBADO"}));
    }

    const handlePublished = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateVacancies(token, DataSelected.id, {"estado": "PUBLICADO"}));
    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Vacantes", link: "/vacantes"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="content-area-wrapper" style={{margin: 0}}>
                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">
                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_vacancies").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm)
                                                        setShowOverlay(!showSibarRight);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-vacancies"
                                                    name="filtro-vacancies"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {
                                                        range_date.visible && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {
                                    permisos.filter(element => element.codigo === "add_vacancies").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''}`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="vacancies">
                                                        Solicitar vacante
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <Input
                                                                label="Título"
                                                                name="titulo"
                                                                value={form.titulo}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                type="date"
                                                                name="fecha_vacante"
                                                                id="fecha_vacante"
                                                                label="Fecha de vacante"
                                                                onChange={handleChange}
                                                                placeholder=""
                                                                value={form.fecha_vacante}
                                                            />
                                                            <Input
                                                                label="Joyería/Departamento"
                                                                name="establecimiento"
                                                                value={form.establecimiento}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                label="Zona/Área"
                                                                name="zona"
                                                                value={form.zona}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                label="Jefe de área/Zona"
                                                                name="jefe_area"
                                                                value={form.jefe_area}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                label="Sub gerente de área"
                                                                name="subjefe_area"
                                                                value={form.subjefe_area}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                label="Razón social"
                                                                name="razon_social"
                                                                value={form.razon_social}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                name="cantidad"
                                                                label="Cantidad de vacante(s)"
                                                                onChange={handleChange}
                                                                type="number"
                                                                min="0"
                                                                value={form.cantidad}
                                                            />
                                                            <Input
                                                                label="Razón de la vacante"
                                                                name="motivo"
                                                                value={form.motivo}
                                                                onChange={handleChange}
                                                            />
                                                            <TextArea
                                                                id="justificativo"
                                                                name="justificativo"
                                                                label="Justificativo"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={2}
                                                                value={form.justificativo}
                                                            />
                                                            <TextArea
                                                                id="funcion_principal"
                                                                name="funcion_principal"
                                                                label="Funciones principales"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={2}
                                                                value={form.funcion_principal}
                                                            />
                                                            <TextArea
                                                                id="condicion"
                                                                name="condicion"
                                                                label="Condiciones del espacio físico"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={2}
                                                                value={form.condicion}
                                                            />
                                                            <TextArea
                                                                id="herramienta_trabajo"
                                                                name="herramienta_trabajo"
                                                                label="Herramientas de trabajo"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={2}
                                                                value={form.herramienta_trabajo}
                                                            />
                                                            <TextArea
                                                                id="herramienta_informatica"
                                                                name="herramienta_informatica"
                                                                label="Herramientas informáticas o para cumplimiento de tareas"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={2}
                                                                value={form.herramienta_informatica}
                                                            />
                                                            <CheckBox label="Correo electrónico"
                                                                  name="tiene_correo" id="tiene_correo"
                                                                  onChange={(e) => {
                                                                      setForm({
                                                                          ...form,
                                                                          tiene_correo: e.target.checked,
                                                                      });
                                                                  }}
                                                                  state={form.tiene_correo}/>
                                                            <br/>
                                                            {form.tiene_correo === true &&
                                                                <Input
                                                                    label="Correo"
                                                                    name="correo"
                                                                    value={form.correo}
                                                                    onChange={handleChange}
                                                                />
                                                            }
                                                            <TextArea
                                                                id="equipo_proteccion"
                                                                name="equipo_proteccion"
                                                                label="Equipos de protección"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={2}
                                                                value={form.equipo_proteccion}
                                                            />
                                                            <Input
                                                                label="Tipo de contrato"
                                                                name="tipo_contrato"
                                                                value={form.tipo_contrato}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                label="Jornada de trabajo"
                                                                name="jornada_trabajo"
                                                                value={form.jornada_trabajo}
                                                                onChange={handleChange}
                                                            />
                                                            <Input
                                                                name="salario"
                                                                label="Salario"
                                                                onChange={handleChange}
                                                                type="number"
                                                                min="0"
                                                                step="0.01"
                                                                value={form.salario}
                                                            />
                                                            <TextArea
                                                                id="otro_detalle"
                                                                name="otro_detalle"
                                                                label="Otros detalles de salario"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={2}
                                                                value={form.otro_detalle}
                                                            />
                                                            <CheckBox label="¿Cuenta con presupuesto?"
                                                                name="presupuesto" id="presupuesto"
                                                                onChange={(e) => {
                                                                    setForm({
                                                                          ...form,
                                                                          presupuesto: e.target.checked,
                                                                      });
                                                                  }}
                                                                state={form.presupuesto}/>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR VACANCIESA
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento o número de solicitud"}
                                                                            onChange={handleSearch}
                                                                    />
                                                                </div>
                                                                {permisos.filter(element => element.codigo === "generate_excel_vacancies").length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i
                                                                                className="text-white bx bx-export"/>
                                                                            </h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={handleGenerateReport}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}
                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.titulo}
                                                                    subtitle={item.secuencial}
                                                                    rightDescription={item.estado}
                                                                    bulletType={get_status(item.estado)}
                                                                    children={
                                                                        <div className="user-details div_fecha">
                                                                            <div className="mail-items">
                                                                                <small>Establecimiento: {item.establecimiento}</small><br/>
                                                                                <small>Fecha: {item.fecha_vacante}</small>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}

                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                                <div className="email-header-right mb-1 ml-2 pl-1">
                                                    <span
                                                        className={`badge badge-light-${get_status(DataSelected.estado)} badge-pill ml-1`}>
                                                        {DataSelected.estado}
                                                    </span>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.titulo}
                                                                subtitle={"Fehca de vacante: " + DataSelected.fecha_vacante}
                                                                description={"Fehca de creación: " + DataSelected.fecha_vacante}
                                                            >
                                                                <div className="row">
                                                                    {(DataSelected.establecimiento) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Joyería/Departamento: </h6>{DataSelected.establecimiento}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.zona) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Zona/Área: </h6>{DataSelected.zona}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.jefe_area) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Jefe de área/Zona: </h6>{DataSelected.jefe_area}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.subjefe_area) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Sub gerente de área: </h6>{DataSelected.subjefe_area}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.razon_social) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Razón social: </h6>{DataSelected.razon_social}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.cantidad) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Cantidad de vacante(s): </h6>{DataSelected.cantidad}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.motivo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Razón de la vacante: </h6>{DataSelected.motivo}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.justificativo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Justificativo: </h6>{DataSelected.justificativo}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.funcion_principal) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Funciones principales: </h6>{DataSelected.funcion_principal}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.condicion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Condiciones del espacio físico: </h6>{DataSelected.condicion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.herramienta_trabajo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Herramientas de trabajo: </h6>{DataSelected.herramienta_trabajo}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.herramienta_informatica) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Herramientas informáticas o para cumplimiento de tareas: </h6>{DataSelected.herramienta_informatica}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.correo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Correo electrónico: </h6>{DataSelected.correo}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.equipo_proteccion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Equipos de protección: </h6>{DataSelected.equipo_proteccion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.tipo_contrato) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Tipo de contrato: </h6>{DataSelected.tipo_contrato}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.jornada_trabajo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Jornada de trabajo: </h6>{DataSelected.jornada_trabajo}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.salario) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Salario: </h6>{DataSelected.salario}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.otro_detalle) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Otros detalles de salario: </h6>{DataSelected.otro_detalle}
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 mb-1">
                                                                        <h6>¿Cuenta con presupuesto?</h6>{DataSelected.estimado === true ? "SI" : "NO"}
                                                                    </div>
                                                                    {(DataSelected.observacion) &&
                                                                       <div className="col-12 mb-1">
                                                                            <h6>Observación: </h6>{DataSelected.observacion}
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 div-flex mt-2 mb-5">
                                                                        {(permisos.filter(item => item.codigo === "decline_vacancies").length > 0  && DataSelected.estado !== "RECHAZADO") &&
                                                                            <Button
                                                                                text="Rechazar"
                                                                                onChange={
                                                                                    () => {
                                                                                        setObservation("");
                                                                                        setModalDecline(true);
                                                                                    }
                                                                                }
                                                                                theme="danger"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                        {(permisos.filter(item => item.codigo === "aprobal_vacancies").length > 0 && DataSelected.estado === "PENDIENTE") &&
                                                                                <Button
                                                                                    text="Aprobar"
                                                                                    onClick={handleApproval}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="submit"
                                                                                    disabled={isLoading}
                                                                                />
                                                                        }
                                                                        {permisos.filter(item => item.codigo === "published_vacancies").length > 0 && DataSelected.estado === "APROBADO" && (
                                                                            <Button
                                                                                text="Publicar"
                                                                                onClick={handlePublished}
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="submit"
                                                                                disabled={isLoading}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modalDecline}>
                <form onSubmit={handleDecline}>
                    <div className="card-body">
                        <h5 className="mb-2">Rechazar Vacante</h5>
                        <div className="form-group">
                            <TextArea
                                id="observacion"
                                name="observacion"
                                label="Observación"
                                placeholder=""
                                onChange={(e) => setObservation(e.target.value)}
                                rows={4}
                                value={observation}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button className={`btn btn-success button_div`} disabled={isLoading}>Continuar</button>
                        <button type="button" onClick={() => {
                            setModalDecline(false);
                        }} className={`btn btn-outline-danger button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default VacanciasAdmin;
